import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useI18n } from "@/context/I18nContext";
import { openCookieSettings } from "@/components/CookieConsent";

export const PoweredBy = () => {
  const { t } = useI18n();
  return <p className="absolute bottom-4 inset-x-0 text-center text-[10px] text-slate-500 tracking-wide" data-testid="page-powered-by">{t("ft.powered")}</p>;
};

export const Footer = ({ className = "" }) => {
  const { t } = useI18n();
  const [ver, setVer] = useState("");
  useEffect(() => { api.get("/version").then((r) => setVer(r.data.version)).catch(() => {}); }, []);
  return (
    <footer className={`border-t border-white/5 px-4 sm:px-6 lg:px-10 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-slate-500 ${className}`} data-testid="site-footer">
      <div className="flex flex-col items-center md:items-start gap-1">
        <div className="flex items-center gap-3">
          <img src="/logo-x.png" alt="" className="w-7 h-auto" />
          <span data-testid="footer-copyright">© {new Date().getFullYear()} CLIP-EX™. {t("ft.rights")}</span>
        </div>
        <span className="text-[10px] text-slate-500 tracking-wide" data-testid="footer-powered-by">{t("ft.powered")}</span>
      </div>
      <nav className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2">
        <Link to="/confidentialite" className="hover:text-white transition-colors" data-testid="footer-privacy-link">{t("ft.privacy")}</Link>
        <Link to="/conditions" className="hover:text-white transition-colors" data-testid="footer-terms-link">{t("ft.terms")}</Link>
        <Link to="/parrains" className="hover:text-white transition-colors" data-testid="footer-parrains-link">{t("rl.footer")}</Link>
        <button onClick={openCookieSettings} className="hover:text-white transition-colors" data-testid="footer-cookies-btn">{t("ft.cookies")}</button>
        <span className="text-[#3ad7ff]/70 font-mono">{t("ft.law25")}</span>
        {ver && <Link to="/nouveautes" className="font-mono text-[#c79bff] hover:text-white transition-colors" data-testid="footer-version-link">V{ver}</Link>}
      </nav>
    </footer>
  );
};
